import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_tag",
  "use": "icon-project_tag-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_tag\"><g transform=\"rotate(-45 21.743 12.207)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path stroke-linejoin=\"round\" d=\"M8 0h16.73L30 8l-5.27 8H8\" /><circle cx=\"8\" cy=\"8\" r=\"2\" /><path d=\"M8 0a8 8 0 100 16\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol